import { createAsyncThunk } from "@reduxjs/toolkit";
import { ICmsItem } from "../../api/dto/cms/ICmsItem";
import { fetchAllCms, fetchCmsDataByFilter, publishCms } from "../../api/requests/cms";

export const getCmsDataThunk = createAsyncThunk<ICmsItem, string>("section/getCms", async (type, { rejectWithValue }) => {
  return await fetchCmsDataByFilter(type).catch((error) => rejectWithValue({ error }));
});

export const getAllCmsDataThunk = createAsyncThunk<ICmsItem[], string>("section/getAllCms", async (name, { rejectWithValue }) => {
  return await fetchAllCms(name).catch((error) => rejectWithValue({ error }));
});

export const publishCmsDataThunk = createAsyncThunk<ICmsItem, ICmsItem>("section/publishCms", async (cms, { rejectWithValue }) => {
  return await publishCms(cms).catch((error) => rejectWithValue({ error }));
});
